import { validate } from 'email-validator';

export default function(email) {
  if (!validate(email)) {
    return "Must be a valid email'";
  }
  return undefined;
}
